import { useState } from "react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import api, { apiError } from "@/lib/api";

const NAMES = {
  truecrime: "True Crime Narrator",
  hype: "Hype Coach",
  documentary: "Documentary Voice",
  storyteller: "The Storyteller",
  mentor: "Wise Mentor",
  sports: "Sports Commentator",
  luxury: "Luxury Insider",
  horror: "Midnight Whisper",
  comedy: "The Roastmaster",
  finance: "The Analyst",
};

export default function NarratorCard({ videoId, voiceId, enabled, onSaved }) {
  const [busy, setBusy] = useState(false);
  if (!voiceId?.startsWith("narrator:")) return null;
  const key = voiceId.split(":")[1];

  const save = async (next) => {
    setBusy(true);
    try {
      await api.put(`/videos/${videoId}/narrator-overlay`, { enabled: next });
      toast.success(next ? "Narrator will appear on screen — build the video to apply" : "On-screen narrator off for the next build");
      onSaved();
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="border border-white/10 rounded-md bg-[#121212] p-4" data-testid="narrator-card">
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-start gap-3 min-w-0">
          <img
            src={`${process.env.REACT_APP_BACKEND_URL}/api/narrators/${key}/avatar`}
            alt={NAMES[key] || "AI narrator"}
            className="h-9 w-9 rounded-full shrink-0"
            data-testid="narrator-card-avatar"
          />
          <div className="min-w-0">
            <p className="text-sm font-semibold">{NAMES[key] || "AI narrator"} on screen</p>
            <p className="text-xs text-zinc-500">
            Show your narrator's animated badge in the corner of the video — it bounces in rhythm with the narration, like a podcast host on camera.
            </p>
          </div>
        </div>
        <Switch
          checked={!!enabled}
          onCheckedChange={save}
          disabled={busy}
          data-testid="narrator-overlay-toggle"
          className="data-[state=checked]:bg-amber-500"
        />
      </div>
    </div>
  );
}
